<template>
  <div class="main-container">
    <!-- <div class="main-header">
      <div>
        <h4>Chats</h4>
        <span></span>
      </div>
    </div> -->
    <div class="content-container">
      <div class="chat-container">
        <div class="chat-overview" v-if="chat.messages.length === 0">
          <!-- <div class="logo">
            <img :src="'./static/icons/details_d.PNG'" alt="Logo" />
          </div> -->
          <div class="cards">
            <!-- <a href="#" class="card">
               <div class="icon">🎁</div>
              <p>The latest artist fees in a specific city.</p>
            </a>
            <a href="#" class="card">
              <p>The recent average artist fees paid in a specific city.</p>
            </a>
            <a href="#" class="card">
              <p>The latest artist fees in a specific venue.</p>
            </a>
            <a href="#" class="card">
              <p>The latest artist fees for a specific artist.</p>
            </a>
            <a href="#" class="card">
              <p>The latest invoices for a specific promoter.</p>
            </a>
            <a href="#" class="card">
              <p>The flight options between two cities on a specific date.</p>
            </a>
            <a href="#" class="card">
              <p>Set an exclusivity radius of an event around a location.</p>
            </a>
            <a href="#" class="card">
              <p>Get a summary of the monthly calendar.</p>
            </a> -->
            <a
              href="#"
              class="card"
              v-for="(command, index) in aiCommands"
              :key="command.command_id"
            >
              <p>{{ command.description }}</p>
            </a>
          </div>
        </div>
        <div class="chat-messages" v-else>
          <div
            v-for="(message, index) in chat.messages"
            :key="index"
            :class="`message ${message.sender}-message`"
          >
            <img
              v-if="message.sender === 'bot'"
              :src="'./static/icons/details_d.PNG'"
              alt="Bot Icon"
            />
            <span v-if="message.sender == 'user'">{{
              message.content.text
            }}</span>
            <span v-else>
              <div class="ut-fc">
                <div
                  v-if="
                    message &&
                    message.content &&
                    message.content.command &&
                    message.content.command.metadata &&
                    message.content.command.metadata.command_type ===
                      'update' &&
                    message.content.success === true
                  "
                >
                  <AccordionBadge
                    :message="message"
                    :messageIndex="index"
                    @onsuccess="handleOnSuccess"
                  />
                </div>
                <div
                  class="gpt-text"
                  v-if="
                    message &&
                    message.content &&
                    message.content.command &&
                    message.content.command.metadata &&
                    message.content.command.metadata.command_type ===
                      'update' &&
                    message.content.success === true &&
                    message.updateApiResponse &&
                    message.updateApiResponse.message
                  "
                  v-html="message.updateApiResponse.message"
                ></div>
                <div v-else class="gpt-text">
                  {{ message.content && message.content.response }}
                </div>
                <div
                  v-if="
                    message &&
                    message.content &&
                    message.content.commands &&
                    message.content.commands.length > 1
                  "
                  class="command-options"
                >
                  <div
                    class="command-options--item"
                    v-for="(command, index) in message.content.commands"
                    :key="index"
                    @click="onSelectCommandOption(command)"
                  >
                    {{ command.response }}
                  </div>
                </div>
                <div
                  v-if="
                    message &&
                    message.content &&
                    message.content.command &&
                    message.content.command.metadata &&
                    message.content.command.metadata.command_type === 'list'
                  "
                >
                  <ListRenderer
                    v-if="
                      message &&
                      message.api_response &&
                      message.api_response.data &&
                      message.api_response.success
                    "
                    :list="
                      (message &&
                        message.api_response &&
                        message.api_response.data) ||
                      []
                    "
                    :total_count="
                      (message &&
                        message.api_response &&
                        message.api_response.total_count) ||
                      (message &&
                        message.api_response &&
                        message.api_response.data &&
                        message.api_response.data.length)
                    "
                    :total="
                      (message &&
                        message.api_response &&
                        message.api_response.total_count) ||
                      0
                    "
                    :columns="
                      message &&
                      message.content &&
                      message.content.command &&
                      message.content.command.metadata &&
                      message.content.command.metadata.columns
                    "
                  />
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div class="commands">
        <div class="input-box">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                fill="black"
                fill-rule="evenodd"
                d="M9 7a5 5 0 0 1 10 0v8a7 7 0 1 1-14 0V9a1 1 0 0 1 2 0v6a5 5 0 0 0 10 0V7a3 3 0 1 0-6 0v8a1 1 0 1 0 2 0V9a1 1 0 1 1 2 0v6a3 3 0 1 1-6 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <!-- Paperclip Unicode Character -->
          <input
            type="text"
            v-model="userMessage"
            placeholder="Message DetailsGPT"
            @keyup.enter="onPromptSend"
            :readonly="sendChatMessageLoading"
          />
          <div class="send-button" @click="onPromptSend">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="none"
              viewBox="0 0 32 32"
              class="icon-2xl"
            >
              <path
                d="M15.192 8.906a1.143 1.143 0 0 1 1.616 0l5.143 5.143a1.143 1.143 0 0 1-1.616 1.616l-3.192-3.192v9.813a1.143 1.143 0 0 1-2.286 0v-9.813l-3.192 3.192a1.143 1.143 0 1 1-1.616-1.616z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dtGPTActions } from "../../../store/app/dtgpt/actions";
import { dtGPTGetters } from "../../../store/app/dtgpt/getters";
import {
  mapActionObject,
  mapAppActionObject,
  mapAppGetterObject,
  mapGetterObject,
} from "../../../store/global";

import * as dtGPTTypes from "../../../store/app/dtgpt/types";

//import { SelectTree, createNode } from "../../../../plugins/select-tree";
// import { createGridHost } from "@/dt-plugins/sidewindow/grid-host.mixin";
// import { contactImportExportGrid } from "./import-export/sw-grid";

// import { createModalMixin } from '@/dt-plugins/modal/modal.mixin';

// import FileDownload from "js-file-download";
// import { ContactIMEXService } from "../services/contact_import_export.service";
// import CompareModal from './import-export/merge-contact-compare-modal';
// import ModalContainer from "@dtplugins/modal/modal-container";
// import ImportItemBox from "./import-export/item-box";
// import ImportCSV from "./import-export/import-csv";
// import ImportVcard from "./import-export/import-vcard";

import JSONRenderer from "./json-renderer";
import ListRenderer from "./list-renderer";
import AccordionBadge from "./accordion-badge";

export default {
  components: {
    ListRenderer,
    JSONRenderer,
    AccordionBadge,
    // ModalContainer,
    // ImportItemBox,
    // ImportCSV,
    // ImportVcard,
    // CompareModal
  },
  props: [],
  data() {
    return {
      userMessage: "",
      testMessage: `<a href="#/main/booking/booking_list/4327/overview">2024-05-25</a> - ://about blank Club: berlin, Germany<br><a href="#/main/booking/booking_list/4331/overview">2024-08-25</a> - ://about blank Club: Berlin, Germany`,
    };
  },
  computed: {
    ...mapAppGetterObject(dtGPTGetters),
    aiCommands() {
      console.log("mdsir route:", this.$route);
      const { name, path } = this.$route;
      const dt_module = path.split("/")[2];
      const commands = this.$store?.getters?.account?.ai_commands || [];
      // return commands.filter(r => r.section == dt_module);
      return commands.filter(
        (r) => !r?.route || (r?.route || "").split(",").includes(name)
      );
    },
  },
  methods: {
    ...mapAppActionObject(dtGPTActions),
    onPromptSend() {
      console.log("onPromptSend", this.userMessage);
      if (this.userMessage == "" || this.sendChatMessageLoading === true) {
        return;
      }

      this[dtGPTTypes.SEND_CHAT_MESSAGE]({
        text: this.userMessage,
      });
      this.userMessage = "";
    },
    onSelectCommandOption(command) {
      this[dtGPTTypes.SEND_CHAT_MESSAGE]({
        text: command.response,
      });
      this.userMessage = "";
    },
    // "onsuccess": [
    //   {
    //     "action": "redirectAndRefresh",
    //     "parameters": {
    //       "path": "main/booking/booking_list/<calendar_date_id>/overview",
    //       "store": {
    //         "action": "BookingStore/SET_SELECTED_BOOKING",
    //         "payload": {
    //           "calendar_date_id": "<calendar_date_id>"
    //         }
    //       }
    //     }
    //   }
    // ]
    handleOnSuccess(message) {
      const onSuccess = message?.content?.command?.metadata?.onsuccess;
      const args = message.content?.args;
      console.log({ onSuccess });

      for (const process of onSuccess) {
        if (process.action === "redirectAndRefresh") {
          console.log("redirectAndRefresh", process, args);
          const path = process.parameters.path;

          const populatePath = (path) => {
            const matches = path.match(/<([^>]+)>/g);
            if (matches) {
              for (const match of matches) {
                const key = match.replace(/<|>/g, "");
                path = path.replace(match, args[key]);
              }
            }
            return path;
          };

          console.log({ path: populatePath(path) });
          const currentPath = this.$route.path;
          const finalPath = populatePath(path);

          if (currentPath === finalPath) {
            console.log("It is the same Path, Staying on the same page");
          } else {
            this.$router.push({
              path: populatePath(path),
            });
          }

          const store = process.parameters.store;

          // Constrcute Store Payload

          const constructPayload = (payload) => {
            let constructedPayload = {};
            const matches = JSON.stringify(payload).match(/<([^>]+)>/g);
            if (matches) {
              for (const match of matches) {
                const key = match.replace(/<|>/g, "");
                constructedPayload = JSON.parse(
                  JSON.stringify(payload).replace(match, args[key])
                );
              }
            }
            return constructedPayload;
          };

          // Dispatch store action
          this.$store.dispatch(store.action, constructPayload(store.payload));

          // this.$store.commit(store.action, store.payload);
        }
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: calc(100vh - 25px);
  padding: 0 10px;
  // overflow: auto;
  .main-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 50px;
    h4 {
      color: #282828;
      font-weight: 500;
      text-transform: uppercase;
      opacity: 1;
      font: normal normal bold 13px/18px Roboto;
    }
  }
  .content-container {
    padding-top: 150px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 75px);
    // height: calc(100% + 200px);
    // padding: 10px 100px;
    align-items: center;
    .chats {
      flex: 9;
      width: 800px;
    }

    .chat-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      // flex: 1;
      // overflow-y: scroll;
      // -ms-overflow-style: none; /* IE and Edge */
      // scrollbar-width: none; /* Firefox */
      // padding: 0 20px 20px 20px;
      box-sizing: border-box;
      flex: 9;
      width: 800px;
      height: 100%;

      // &::-webkit-scrollbar {
      //   display: none; /* Safari and Chrome */
      // }

      .chat-messages {
        overflow-y: scroll;
        width: 100%;
        height: 100%;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        padding: 20px;

        &::-webkit-scrollbar {
          display: none; /* Safari and Chrome */
        }

        .message {
          display: flex;
          margin-bottom: 20px;
          align-items: flex-start;

          span {
            background: #e0e0e0;
            padding: 10px 15px;
            border-radius: 10px;
            max-width: 60%;
            word-wrap: break-word;
            // box-shadow: 0 6px 9px rgba(0, 0, 0, 0.1);
            box-shadow: 0px 4px 15px 0px #6e6e6e;
          }
        }

        .user-message {
          justify-content: flex-end;

          span {
            // background: #f2f2f2;
            color: black;
            border-radius: 10px;
            padding: 10px;
            font-size: 14px;
          }
        }

        .bot-message {
          justify-content: flex-start;

          span {
            // background: #f2f2f2;
            color: black;
            border-radius: 10px;
            padding: 10px;
            font-size: 14px;
          }

          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 10px;
            padding: 2px;
            background: #e0e0e0;
          }
        }
      }

      .chat-overview {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        text-align: center;
        // overflow-y: fixed;
        height: calc(100vh - 75px);
        padding: 20px;

        padding: 8px;
        .logo {
          img {
            width: 80px;
            height: auto;
            margin-bottom: 50px;
          }
        }

        .cards {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
          // padding-bottom: 20px;
        }

        .card {
          background-color: #fff;
          border: 1px solid #e0e0e0;
          border-radius: 10px;
          box-shadow: 0px 4px 13px 0px #6e6e6e;
          padding: 20px;
          width: 170px;
          text-align: center;
          text-decoration: none;
          color: #333;
          transition: transform 0.2s, background-color 0.2s;
        }

        .card:hover {
          transform: translateY(-5px);
          background-color: #f0f0f0;
          /* Change background color on hover */
        }

        .icon {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .card p {
          margin: 0;
          font-size: 14px;
          color: inherit;
        }
      }
    }

    .commands {
      flex: 0.8;
      width: 800px;
      // .input-box {
      //   width: 100%;
      //   background: #fff;
      //   border: 1px solid #333;
      //   border-radius: 10px;
      //   padding: 15px;
      //   display: flex;
      //   // align-items: center;
      //   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      //   box-sizing: border-box;

      //   .icon {
      //     margin-right: 10px;
      //     font-size: 24px;
      //   }

      //   input {
      //     width: 100%;
      //     border: none;
      //     outline: none;
      //     font-size: 16px;
      //   }
      // }

      .input-box {
        // position: fixed;
        // bottom: 10px;
        // left: 50%;
        // transform: translateX(-50%);
        // width: calc(100% - 20px);
        // max-width: 600px;
        width: 100%;
        background: #f5f5f5;
        border-radius: 30px;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;

        .icon {
          font-size: 24px;
          margin-right: 10px;
        }

        input {
          flex: 1;
          border: none;
          outline: none;
          font-size: 16px;
          background: transparent;
          color: #7f7f7f;
        }

        .send-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          background: #e0e0e0;
          border-radius: 50%;
          cursor: pointer;
          margin-left: 10px;

          svg {
            fill: #f4f4f4;
          }
        }
      }
    }
  }
  .menu-container {
    margin-top: 0px !important;
  }

  .ut-fc .api_response--updated {
    padding: 10px;
    border-radius: 5px;
    background-color: #f5f5f5;
  }

  .gpt-text {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .command-options {
    display: flex;
    flex-direction: column;
    padding: 10px;
    // background-color: #f9f9f9;
    border-radius: 5px;

    .command-options--item {
      cursor: pointer;
      padding: 8px;
      margin-bottom: 5px;
      background-color: #ffffff69;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #ffffffe9;
      }
    }
  }
}
</style>
